export default __webpack_public_path__ + "static/media/app-footer-logo.4a81d29d.svg";